var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "black 1",
    clipPath: "url(#clip0_9320_112187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.00098 -1H12.1437L12.048 16.9047H8.71455C8.71455 16.9047 8.52389 6.14307 7.38082 4.14292C7.38082 4.14292 6.23819 11.7626 6.23819 17H3.09542L3.00098 -1Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9320_112187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9996,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlack1);
export default __webpack_public_path__ + "static/media/black 1.bf201d57928643a07d0a14f4f02ab88f.svg";
export { ForwardRef as ReactComponent };